import { defineAction } from '~/prix'
import { z } from 'zod'
import variableSyncCatalogAction from './variableSyncCatalog.action.json' with { type: 'json' }

const variableSyncCatalogDefinition = defineAction({
  ...variableSyncCatalogAction,
  input: z.object({}),
  output: z.object({
    variablesCount: z.number(),
    deletedCount: z.number(),
  }),
})

export default variableSyncCatalogDefinition
